import { formatDate } from '@ProdWb/logic'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { OPS_PRODUCTION_PATH } from '~/redux-modules/preferences'
import { ExceptionListHeaderType } from '../types'
import styles from '../styles.css'

export const PLACEMENT = 'exceptions-failurs-drawer'

export const ExceptionsListHeader = (props: ExceptionListHeaderType) => {
    const { id, name, updatedAt } = props

    return (
        <Box justifyContent="between">
            <Box alignItems="center">
                <span className={styles.createExceptionButtonContainer}>
                    <Link
                        name="view-exception-details"
                        placement={PLACEMENT}
                        data-test-target="view-exception-details"
                        from={`${OPS_PRODUCTION_PATH}/jobs`}
                        href={`${OPS_PRODUCTION_PATH}/exception-details/${id}/notes`}
                        target="_blank"
                    >
                        <Text className={styles.exceptionFailureName}>
                            {name}
                        </Text>
                    </Link>
                </span>
                <span className={styles.divider} />
                <Text className={styles.exceptionFailureUpdatedDate}>
                    Last updated : {formatDate(updatedAt)}
                </Text>
            </Box>
        </Box>
    )
}
